import debug from 'debug';

const BASE = 'chart-alert-app';
const COLORS = {
  trace: 'lightblue',
  info: 'blue',
  warn: 'orange',
  error: 'red',
};

class Log {
  generateMessage(level, message, source) {
    const namespace = `${BASE}:${level}`;
    const createDebug = debug(namespace);

    createDebug.color = COLORS[level];

    if (source) {
      createDebug(source, message);
    } else {
      createDebug(message);
    }
  }

  trace(message, source) {
    if (process.env.NODE_ENV !== 'production') {
      return this.generateMessage('trace', message, source);
    }
  }

  info(message, source) {
    return this.generateMessage('info', message, source);
  }

  warn(message, source) {
    return this.generateMessage('warn', message, source);
  }

  error(message, source) {
    return this.generateMessage('error', message, source);
  }
}

export default new Log();
